module.exports = __webpack_public_path__ + "img/img30.0bccebe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/02/img30.png
// module id = 208
// module chunks = 0